import { BaseError } from "./base.js";
export class TransactionMissingToParamError extends BaseError {
    constructor() {
        super("Transaction is missing `to` address set on request");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionMissingToParamError"
        });
    }
}
export class FailedToFindTransactionError extends BaseError {
    constructor(hash) {
        super(`Failed to find transaction for user operation ${hash}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FailedToFindTransactionError"
        });
    }
}
//# sourceMappingURL=transaction.js.map